import FieldWrapper from './field-wrapper';
import { useController, UseControllerProps, FieldValues, useFormContext } from 'react-hook-form';
import { DateInput } from 'shared/ui/controls/date-input';

export interface DateFieldProps<T extends FieldValues> extends UseControllerProps<T> {
  label: string;
  isSmallSize?: boolean;
  position?: 'auto' | 'above' | 'below';
  required?: boolean;
}

export const DateInputField = <T extends FieldValues>({
  label,
  isSmallSize,
  position,
  required,
  ...props
}: DateFieldProps<T>) => {
  const { trigger } = useFormContext();

  const {
    field,
    fieldState: { error }
  } = useController({
    ...props
  });

  return (
    <FieldWrapper label={label} error={error} required={required}>
      <DateInput
        isSmallSize={isSmallSize}
        error={error}
        value={field.value}
        onChange={field.onChange}
        onDateChange={(value) => {
          field.onChange(value);
          trigger(field.name);
        }}
        position={position}
      />
    </FieldWrapper>
  );
};
